import classnames from 'classnames';
import { DataTreeNode } from "./components/DataTreeNode/DataTreeNode.js";
import styles from "./components/DataTreeNode/DataTreeNode.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function DataTree({
  data,
  className,
  variant = 'WHITE',
  ...nodeProps
}) {
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "data-tree",
    className: classnames(styles.childrenGrid, styles[variant], className),
    children: data.map(data => {
      return /*#__PURE__*/_jsx(DataTreeNode, {
        data: data,
        ...nodeProps,
        level: 0
      }, data.id);
    })
  });
}